// import mec from "../assets/products/vyra-mec.jpg";
import sample from "../../assets/sample.png";
import ayfer from "../../assets/products/ayfer.png";
import ayferL from "../../assets/products/ayferL.png";
import ayferR from "../../assets/products/ayferR.png";
import calzonect from "../../assets/products/Calzonect.png";
import calzonectR from "../../assets/products/CalzonectR.png";
import calzonectL from "../../assets/products/CalzonectL.png";
import vyramomR from "../../assets/products/vyramomR.png";
import vyramomL from "../../assets/products/vyramomL.png";
import vyramom from "../../assets/products/vyramom.png";
import ramirabdsrR from "../../assets/products/ramirabdsrR.png";
import ramirabdsrL from "../../assets/products/ramirabdsrL.png";
import ramirabdsr from "../../assets/products/ramirabdsr.png";
import ramirabl from "../../assets/products/ramirabl.png";
import uditakeR from "../../assets/products/uditakeR.png";
import uditakeL from "../../assets/products/uditakeL.png";
import uditake from "../../assets/products/uditake.png";
import osteraR from "../../assets/products/osteraR.png";
import osteraL from "../../assets/products/osteraL.png";
import ostera from "../../assets/products/ostera.png";
import vyranervR from "../../assets/products/vyranervR.png";
import vyranervL from "../../assets/products/vyranervL.png";
import vyranerv from "../../assets/products/vyranerv.png";
import shayflamL from "../../assets/products/shayflamL.png";
import shayflamR from "../../assets/products/shayflamR.png";
import shayflam from "../../assets/products/shayflam.png";
import zainclavlbR from "../../assets/products/zainclaclbR.png";
import zainclavlbL from "../../assets/products/zainclaclbL.png";
import zainclavlb from "../../assets/products/zainclaclb.png";
import podrixcvR from "../../assets/products/podrixcvR.png";
import podrixcvL from "../../assets/products/podrixcvL.png";
import podrixcv from "../../assets/products/podrixcv.png";
import zaintilcvR from "../../assets/products/zaintilcvR.png";
import zaintilcvL from "../../assets/products/zaintilcvL.png";
import zaintilcv from "../../assets/products/zaintilcv.png";
import hiluxR from "../../assets/products/hiluxR.png";
import hiluxL from "../../assets/products/hiluxL.png";
import hilux from "../../assets/products/hilux.png";
import hyluxjrR from "../../assets/products/hyluxjrR.png";
import hyluxjrL from "../../assets/products/hyluxjrL.png";
import hyluxjr from "../../assets/products/hyluxjr.png";
import QteraR from "../../assets/products/QteraR.png";
import QteraL from "../../assets/products/QteraL.png";
import Qtera from "../../assets/products/Qtera.png";
import mlctR from "../../assets/products/mlctR.png";
import mlctL from "../../assets/products/mlctL.png";
import mlct from "../../assets/products/mlct.png";
import vyrazincR from "../../assets/products/vyrazincR.png";
import vyrazincL from "../../assets/products/vyrazincL.png";
import vyrazinc from "../../assets/products/vyrazinc.png";
import rambowlR from "../../assets/products/rambowlR.png";
import rambowlL from "../../assets/products/rambowlL.png";
import rambowl from "../../assets/products/rambowl.png";
import arginentR from "../../assets/products/arginentR.png";
import arginentL from "../../assets/products/arginentL.png";
import arginent from "../../assets/products/arginent.png";

export const productsFiles = [
  {
    id: 1,
    name: "AYFER-XT Tablet",
    composition: "Ferrous Ascorbate 100mg + Folic Acid 1.5mg + Zinc 22.5mg",
    category: "Hematinic",
    image: ayfer,
    imageL: ayferL,
    imageR: ayferR,
    description:
      "This formulation contains Ferrous Ascorbate, a highly absorbable form of iron that helps increase hemoglobin levels and improves oxygen transport in the body. Folic Acid supports red blood cell formation and is essential for DNA synthesis, especially beneficial during pregnancy and nutritional deficiency. Zinc plays a key role in immunity, wound healing, and improves overall metabolic functions. Together, this combination helps manage iron deficiency anemia, reduces fatigue and weakness, supports pregnancy-related nutritional needs, and enhances immune function.",
  },
  {
    id: 2,
    name: "CALZONE-CT Softgel Capsule",
    composition: "Calcitriole 0.25mcg + Calcium Carbonate 500mg + Zinc 7.5mg",
    category: "Osteoporotic",
    imageL: calzonectL,
    imageR: calzonectR,
    image: calzonect,
    description:
      "This combination contains Calcitriol, the active form of Vitamin D3, which enhances intestinal absorption of calcium and helps regulate calcium metabolism. Calcium Carbonate provides elemental calcium required for bone formation, strength, and maintenance. Zinc supports bone mineralization, improves immunity, and promotes overall growth and tissue repair. Together, this formulation helps improve bone density, prevents calcium deficiency, supports fracture healing, and is beneficial in conditions like osteoporosis and osteopenia.",
  },
  {
    id: 3,
    name: "VYRAMOM Powder",
    composition: "Protien Powder with DHA Essential Vitamins And Minerals",
    category: "Nutraceuticals",
    imageL: vyramomL,
    imageR: vyramomR,
    image: vyramom,
    description:
      "This formulation contains high-quality Protein to support muscle growth, tissue repair, and overall body strength. DHA (Docosahexaenoic Acid) helps in brain development, memory, and cognitive function. Essential Vitamins and Minerals support immunity, energy production, and proper metabolic activities. Together, this combination helps improve nutritional status, enhances physical strength, supports brain health, and promotes overall well-being in children and adults.",
  },
  {
    id: 4,
    name: "RAMIRAB-DSR Capsule",
    composition: "Rebeprazole 20mg + Domperidone 30mg",
    category: "Gastroentrology",
    imageR: ramirabdsrR,
    imageL: ramirabdsrL,
    image: ramirabdsr,
    description:
      "This formulation contains Rabeprazole, a proton pump inhibitor (PPI) that reduces stomach acid production and helps heal acid-related damage to the stomach and esophagus. Domperidone is a prokinetic agent that improves gastric motility, accelerates stomach emptying, and helps relieve nausea, bloating, and reflux symptoms. Together, this combination provides effective relief from acidity, heartburn, gastroesophageal reflux, and indigestion while improving digestion and reducing gastric discomfort.",
  },
  {
    id: 5,
    name: "RAMIRAB-L Capsule",
    composition: "Rebeprazole 20mg + levosulpride 75mg",
    category: "Gastroentrology",
    image: ramirabl,
    description:
      "This formulation contains Rabeprazole, a proton pump inhibitor that suppresses gastric acid secretion and helps in healing acid-related irritation of the stomach and esophagus. Levosulpiride is a prokinetic agent that enhances gastrointestinal motility, improves gastric emptying, and reduces symptoms like bloating, fullness, and nausea. Together, this combination provides effective relief from acid reflux, gastritis, and indigestion while improving digestive function and reducing upper abdominal discomfort.",
  },
  {
    id: 6,
    name: "UDITAKE-300 Tablet",
    composition: "Ursodeoxycholic Acid 300mg",
    category: "Hepatoprotective Agent",
    imageR: uditakeR,
    imageL: uditakeL,
    image: uditake,
    description:
      "Ursodeoxycholic Acid (UDCA) is a naturally occurring bile acid that reduces cholesterol saturation in bile and helps dissolve cholesterol gallstones. It also improves bile flow and protects liver cells from damage. UDCA is commonly used in liver disorders associated with impaired bile secretion and helps normalize liver enzyme levels. This medication supports liver function, promotes healthy bile flow, and is beneficial in various hepatobiliary conditions.",
  },
  {
    id: 7,
    name: "RAMBOWL Sachet",
    composition: "Lactobacillus Rhamnosus Gg (actc53103)",
    category: "Probiotics",
    imageR: rambowlR,
    imageL: rambowlL,
    image: rambowl,
    description:
      "Lactobacillus rhamnosus GG (ATCC 53103) is a well-studied probiotic strain that helps balance beneficial gut bacteria. It supports intestinal health by inhibiting harmful microorganisms, improving digestion, and enhancing gut barrier function. This probiotic also helps boost immunity and reduces the duration and severity of diarrhea, especially antibiotic-associated diarrhea. It is commonly used to restore gut flora during or after antibiotic therapy and in various gastrointestinal disturbances.",
  },
  {
    id: 8,
    name: "OSTERA Softgel Capsule",
    composition:
      "Calcitriol 0.25mcg + Calcium Carbonate 500mg + Omega-3 Fatty Acid Eq. Epa 90mg + DHA 60mg. + Methylcobalamin 1500mcg + Folic Acid 400mcg + Boron 1.5mg",
    category: "Osteoporotic",
    imageR: osteraR,
    imageL: osteraL,
    image: ostera,
    description:
      "This formulation combines Calcitriol, the active form of Vitamin D3, which enhances calcium absorption and regulates bone metabolism. Calcium Carbonate provides essential calcium for strong bones and teeth. Omega-3 fatty acids (EPA & DHA) support joint health, reduce inflammation, and promote cardiovascular and brain function. Methylcobalamin helps in nerve regeneration and supports healthy nerve function, while Folic Acid aids in red blood cell formation and overall cellular health. Boron plays an important role in calcium metabolism and improves bone mineral density. Together, this combination supports bone strength, improves nerve health, reduces joint discomfort, and helps in nutritional deficiencies.",
  },
  {
    id: 9,
    name: "VYRANERV Injection",
    composition:
      "Methlycobalamin 1500mcg + Pyridoxine Hcl 100mg + Niacinamide 100mg",
    category: "Neuropathy",
    imageR: vyranervR,
    imageL: vyranervL,
    image: vyranerv,
    description:
      "This formulation contains Methylcobalamin (Vitamin B12), which supports nerve regeneration, improves nerve conduction, and helps in the treatment of peripheral neuropathy. Pyridoxine (Vitamin B6) plays an important role in nerve function, neurotransmitter synthesis, and red blood cell formation. Niacinamide (Vitamin B3) supports cellular energy metabolism, improves blood circulation, and helps maintain healthy nervous system function. Together, this combination helps relieve neuropathic symptoms such as numbness, tingling, and burning sensations while supporting overall nerve health and energy metabolism.",
  },
  {
    id: 10,
    name: "SHAYFLAM-SP Tablet",
    composition: "Diclofenac 50mg + Paracetamol 325mg + Serratiopeptidase 15mg",
    category: "Analgesic",
    imageL: shayflamL,
    imageR: shayflamR,
    image: shayflam,
    description:
      "This formulation contains Diclofenac, a non-steroidal anti-inflammatory drug (NSAID) that reduces pain and inflammation. Paracetamol provides additional analgesic and antipyretic action to relieve pain and fever. Serratiopeptidase is a proteolytic enzyme that helps reduce swelling, inflammation, and promotes faster healing of inflamed tissues. Together, this combination provides effective relief from pain, reduces inflammation and swelling, and improves mobility in various musculoskeletal and post-traumatic conditions.",
  },
  {
    id: 11,
    name: "ZAINCLAV-LB Tablet",
    composition:
      "Amoxycilin 500mg + Clavulanic Acid 125mg + Lactic Acid Bacilus 60 Million Spores",
    category: "Antibiotics",
    imageL: zainclavlbL,
    imageR: zainclavlbR,
    image: zainclavlb,
    description:
      "This formulation contains Amoxicillin, a broad-spectrum penicillin antibiotic that inhibits bacterial cell wall synthesis, and Clavulanic Acid, a beta-lactamase inhibitor that enhances the effectiveness of amoxicillin against resistant bacteria. Lactic Acid Bacillus is a probiotic that helps restore beneficial intestinal microflora and reduces the risk of antibiotic-associated diarrhea and gastrointestinal disturbances. Together, this combination effectively treats infections while supporting digestive health and minimizing antibiotic-related side effects.",
  },
  {
    id: 12,
    name: "PODRIX-CV Tablet",
    composition: "Cefpodoxime 200mg + Clavulanic Acid 125mg",
    category: "Antibiotics",
    imageR: podrixcvR,
    imageL: podrixcvL,
    image: podrixcv,
    description:
      "This formulation contains Cefpodoxime, a third-generation cephalosporin antibiotic that inhibits bacterial cell wall synthesis and effectively treats a wide range of bacterial infections. Clavulanic Acid is a beta-lactamase inhibitor that protects cefpodoxime from enzymatic degradation by resistant bacteria, thereby enhancing its antibacterial activity. Together, this combination provides broad-spectrum coverage and is effective against beta-lactamase–producing bacteria, helping in faster resolution of infections.",
  },
  {
    id: 13,
    name: "ZAINTIL-CV Tablet",
    composition: "Cefuroxime Axetil 500mg + Clavulanic Acid 125mg",
    category: "Antibiotics",
    imageR: zaintilcvR,
    imageL: zaintilcvL,
    image: zaintilcv,
    description:
      "This formulation contains Cefuroxime Axetil, a second-generation cephalosporin antibiotic that inhibits bacterial cell wall synthesis and provides effective coverage against a wide range of gram-positive and gram-negative bacteria. Clavulanic Acid is a beta-lactamase inhibitor that protects cefuroxime from degradation by resistant bacteria, thereby enhancing its antibacterial efficacy. Together, this combination offers extended spectrum coverage, helps combat resistant pathogens, and promotes faster recovery from infections.",
  },
  {
    id: 14,
    name: "HYLUX Softgel Capsule",
    composition:
      "Lycopene 4000mcg + Betacarotene 5.17mg + Lutein 4000mcg + Multivitamins + Multiminerals",
    category: "Nutraceuticals",
    imageR: hiluxR,
    imageL: hiluxL,
    image: hilux,
    description:
      "This formulation contains Lycopene, a potent antioxidant that helps protect cells from oxidative stress and supports heart and prostate health. Beta-carotene acts as a precursor of Vitamin A and helps maintain healthy vision, skin, and immune function. Lutein supports eye health by protecting against oxidative damage and improving visual performance. The added multivitamins and multiminerals help fulfill daily nutritional requirements, support metabolism, and enhance overall well-being. Together, this combination helps improve immunity, supports eye and skin health, reduces oxidative stress, and promotes general wellness.",
  },
  {
    id: 15,
    name: "QTERA Tablet",
    composition:
      "Co-Enzyme Q10 100mg + Omega-3 Fatty Acid Eq Epa 90mg + DHA 60mg + Lycopene 2000mcg + Levocarnitine 500mg + L-Arginine 100mg + Zinc 15mg + Magnesium 50mg + Vitamin E 10mg + Selenium 40mg",
    category: "Nutraceuticals",
    imageR: QteraR,
    imageL: QteraL,
    image: Qtera,
    description:
      "This formulation contains Co-Enzyme Q10, which supports cellular energy production and promotes heart health. Omega-3 fatty acids (EPA & DHA) help maintain cardiovascular function and reduce inflammation. Levocarnitine supports energy metabolism and improves muscle performance, while L-Arginine enhances nitric oxide production and supports healthy blood circulation. Lycopene, Vitamin E, and Selenium provide strong antioxidant protection against oxidative stress. Zinc and Magnesium support metabolic functions, muscle health, and immunity. Together, this combination helps improve heart function, enhance energy levels, support male wellness, and protect against oxidative stress.",
  },
  {
    id: 16,
    name: "MLCT Tablet",
    composition: "Montelukast 10mg + levocetrizine 5mg",
    category: "Antihistamine",
    imageR: mlctR,
    imageL: mlctL,
    image: mlct,
    description:
      "This formulation contains Montelukast, a leukotriene receptor antagonist that reduces airway inflammation and helps control allergy-related respiratory symptoms. Levocetirizine is a non-sedating antihistamine that blocks histamine-mediated allergic responses and relieves symptoms such as sneezing, runny nose, itching, and watery eyes. Together, this combination provides effective relief from allergic symptoms, reduces nasal congestion, and improves breathing comfort in seasonal and perennial allergies.",
  },
  {
    id: 17,
    name: "BTMT Tablet",
    composition: "Bilastine 20mg + Montelukast 10mg",
    category: "Antihistamine",
    image: sample,
    description:
      "This formulation contains Bilastine, a non-sedating antihistamine that blocks histamine receptors and helps relieve symptoms such as sneezing, runny nose, itching, and watery eyes. Montelukast is a leukotriene receptor antagonist that reduces airway inflammation and helps control allergy-related respiratory symptoms. Together, this combination provides effective relief from allergic symptoms, improves breathing comfort, and helps control seasonal and perennial allergies.",
  },
  {
    id: 18,
    name: "HYLUX-JR Sugarfree Syrup",
    composition: "L-Lysine 5mg + Multivitamins + Multiminerals",
    category: "Nutraceuticals",
    imageR: hyluxjrR,
    imageL: hyluxjrL,
    image: hyluxjr,
    description:
      "This formulation contains L-Lysine, an essential amino acid that plays an important role in protein synthesis, growth, tissue repair, and calcium absorption. The added multivitamins support energy metabolism, immune function, and overall body performance, while multiminerals help maintain proper physiological functions, bone health, and enzymatic activities. Together, this combination helps improve nutritional status, supports healthy growth, enhances immunity, and promotes overall well-being.",
  },
  {
    id: 19,
    name: "VYRAZINC Syrup",
    composition: "Zing Gluconet 20mg",
    category: "Imunobooster",
    imageR: vyrazincR,
    imageL: vyrazincL,
    image: vyrazinc,
    description:
      "Zinc Gluconate provides elemental zinc, an essential trace mineral involved in numerous enzymatic reactions in the body. It plays a key role in immune function, wound healing, protein synthesis, and cellular growth. Zinc also supports skin health, improves appetite, and helps maintain normal taste and smell sensation. This supplementation is commonly used to prevent and treat zinc deficiency and to support overall health and recovery.",
  },
  {
    id: 20,
    name: "ARGINENT Sachet",
    composition:
      "L-Arginine-3000mg + Taurine-1000mg + L-Leucine-1000mg + L-Lysine Hydrochloride-1000mg",
    category: "Nutraceutical",
    imageR: arginentR,
    imageL: arginentL,
    image: arginent,
    description:
      "ARGINENT Sachet is a scientifically formulated nutritional supplement containing a balanced blend of essential amino acids and taurine to support overall health, energy metabolism, muscle function, and protein synthesis. It helps meet increased nutritional demands during recovery, physical stress, weakness, and periods of inadequate dietary intake. The refreshing orange flavour enhances patient compliance while the sugar-free formulation makes it suitable for a wider range of individuals.",
  },
];
